// extracted by mini-css-extract-plugin
module.exports = {"btn-box":"index-module_btn-box_2aUcx","btn-primary":"index-module_btn-primary_HBYQd","info":"index-module_info_Fbj2X","external-tips":"index-module_external-tips_1yDkw"};